import { Component, DestroyRef, effect, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EntityStatus } from '@core';
import { Store } from '@ngrx/store';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { filter } from 'rxjs';

import { type ChildRelationDevices } from '../../models';
import { DevicesSelectors } from '../../ngrx-store';

@Component({
  imports: [
    NgxSkeletonLoaderModule,
  ],
  selector: 'avs-outlet-plan',
  styleUrl: './outlet-plan.component.scss',
  templateUrl: './outlet-plan.component.html',
})
export class OutletPlanComponent {
  deviceId = input.required<string>();
  outletList = signal<ChildRelationDevices[] | null>(null);
  selectedPortId = input<string | null>();
  selectedPort = output<ChildRelationDevices | null>();
  protected readonly eEntityStatus = EntityStatus;
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);

  constructor() {
    effect(() => {
      this.store.select(DevicesSelectors.getDeviceById(this.deviceId()))
        .pipe(
          filter(Boolean),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe(device => {
          this.outletList.set(device.outletDevices || null);
        });
    });
  }
}
